/**
 * ConsentRequestOverlay – global overlay shown everywhere in the app
 * when a consent request arrives via SSE (REQ-008)
 */
import { useConsentRequests } from "@/hooks/useConsentRequests";
import { ConsentRequestModal } from "./ConsentRequestModal";

export function ConsentRequestOverlay() {
  const { pendingRequests, respond, responding } = useConsentRequests();

  // Show modal for the oldest pending request
  const active = pendingRequests.find((r) => r.status === "PENDING");
  if (!active) return null;

  return (
    <ConsentRequestModal
      request={active}
      onGrant={(id) => respond(id, "GRANT")}
      onDeny={(id) => respond(id, "DENY")}
      responding={responding === active.id}
    />
  );
}
